import styles from './Group.module.css';
import '../../resources/css/admin_style.css';
import NavBar, { NavType } from "../NavBar/NavBar";
import React, { useContext, useEffect, useState } from "react";
import Loading from "../../utils/loading/Loading";
import Header from "../Header/Header";
import { ModalContext } from "../../utils/modal/ModalProvider";
import { IAM_PATH, IAM_SERVER_SERVICE, IAM_SERVER_SERVICE_GROUP, IAM_SERVER_SERVICE_PAGE, IAM_SERVER_SERVICE_PAGEAUTH, IAM_SERVER_SERVICE_ACOUNT, IAM_SERVER_SERVICE_PRODUCT } from "../../utils/Config";
import axios from "../../utils/api/axios";
import GroupTree from './component/GroupTree';
import DetailModal from "../../utils/modal/DetailModal";
import { GroupDetailModal } from "./modal/GroupDetailModal";
import { GroupRegisterModal } from "./modal/GroupRegisterModal";
import { GroupUserRegisterModal } from "./modal/GroupUserRegisterModal";
import { GroupUserDetailModal } from "./modal/GroupUserDetailModal";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import { Tree, Spin, Card } from 'antd';
import GroupUserTable from './component/GroupUserTable';
import { param } from 'jquery';
import { borderBottom } from '@mui/system';
// import { useServiceList } from '../../utils/service/serviceList';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa'

/**
 * 페이지 권한 관리 화면
 * @param isMobile
 * @param setMovePage
 * @returns {JSX.Element}
 * @constructor
 */
function Group({ isMobile, setMovePage }) {
    const { closeModal } = useContext(ModalContext);

    const { openModal } = useContext(ModalContext);
    const [loading, setLoading] = useState(false);
    const [usersLoading, setUsersLoading] = useState(false);

    //검색 조건
    const [selectedKind, setSelectedKind] = useState("");
    const [searchValue, setSearchValue] = useState('');
    const [searchType, setSearchType] = useState('');

    //로그인된 사용자의 서비스 리스트
    // const [serviceList, setServiceList] = useState([]);
    // const {serviceList} = useServiceList();
    //서비스 아이디
    const [selectedServiceId, setSelectedServiceId] = useState('');

    //페이지 데이터, 선택 페이지
    const [treeData, setTreeData] = useState([]);
    const [selectedGroup, setSelectedGroup] = useState(null);
    //선택 페이지 권한 목록
    // const [originalGroupUsers, setOriginalGroupUsers] = useState([]); // 최초 서버에서 받아온 권한 리스트(수정 전)
    const [selectedGroupUsers, setSelectedGroupUsers] = useState([]); // 화면에서 수정 중인 권한 리스트(수정 후)

    const [page, setPage] = useState(0);
    const listSize = 10; // 한 페이지당 보여줄 항목 수

    const [totalCount, setTotalCount] = useState(0);

    const [userInfo, setUserInfo] = useState({
        userId: sessionStorage.getItem("userId"),
        userName: sessionStorage.getItem("userName"),
        groupId: sessionStorage.getItem("groupId"),
        role: sessionStorage.getItem("role")
    })

    const [isMobileWindow, setIsMobileWindow] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobileWindow(window.innerWidth < 768); // 모바일 기준 너비
        };
        handleResize(); // 초기값
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        fetchData();
    }, []);

    //상품 목록 조회
    const [products, setProducts] = useState([]);
    const [idToNameMap, setIdToNameMap] = useState({});
    useEffect(() => {
        const fetchGroups = async () => {
            const map = await getProducts();  // map 반환 받기
            setIdToNameMap(map); // 비동기적으로 idToNameMap 설정
        };
        fetchGroups();
    }, []);

    useEffect(() => {
        // idToNameMap이 비어있지 않을 때만 fetchData 실행
        if (Object.keys(idToNameMap).length > 0) {
            fetchData();  // 인자 없이 idToNameMap 직접 참조
        }
    }, [idToNameMap]);

    const getProducts = async () => {
        const param = {
            startDate: 0,
            endDate: 0,
            page: 0,
            size: -1,
            sortField: [],
            sortOrder: [],
            operator: "",
            conditions: []
        };

        const url = IAM_PATH + IAM_SERVER_SERVICE_PRODUCT + "/products";
        const res = await axios.post(url, param);
        const { data } = res.data;

        // 객체 순회
        const groupList = [];
        const map = {};

        Object.entries(data).forEach(([productId, productData]) => {
            const productObj = {
                id: productId,          // 제품 ID (key)
                name: productData.name, // 제품명
                plans: productData.plans // 요금제 배열
            };

            groupList.push(productObj);
            map[productId] = productObj; // 모든 정보 포함된 객체를 맵에 저장
        });

        setProducts(groupList);     // [{ id: "35", name: "2", plans: [...] }, ...]
        setIdToNameMap(map);
        return map; // ← map 반환
    };

    // 데이터 테이블 조회 API
    const fetchData = async (selectedKey = null) => {
        setLoading(true);

        const param = {
            startDate: 0,
            endDate: 0,
            page: 0,
            size: -1,
            sortField: [],
            sortOrder: [],
            operator: "",
            conditions: []
        };

        try {
            const url = IAM_PATH + IAM_SERVER_SERVICE_GROUP + "/all";
            const res = await axios.post(url, param);
            const { data } = res.data;

            const transformed = transformToTreeData(data);
            setTreeData(transformed);

            if (userInfo.role != "SYS_ADMIN") {
                selectedKey = parseInt(userInfo.groupId) ?? '';
            }

            // 기존 선택 그룹을 찾아서 유지 (selectedKey: groupId string)
            let groupToSelect = selectedKey;
            if (!groupToSelect && selectedGroup) {
                groupToSelect = selectedGroup.key;
            }

            if (groupToSelect) {
                const findGroup = (nodes) => {
                    for (const node of nodes) {
                        if (node.key === groupToSelect) {
                            return node;
                        }
                        if (node.children) {
                            const found = findGroup(node.children);
                            if (found) return found;
                        }
                    }
                    return null;
                };

                const found = findGroup(transformed);
                if (found) {
                    setSelectedGroup(found);
                    // 유저 리스트도 새로 조회
                    getGroupUsersAll(found.key);
                } else {
                    //defualt 그룹 선택해서 가능
                    setSelectedGroup(null);
                    setSelectedGroupUsers([]);
                }
            }

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const transformToTreeData = (data) => {
        return data.map(item => ({
            title: item.groupName,   // 트리에 표시될 텍스트
            // key: item.groupId.toString(), // 고유한 키 (문자열 추천)
            key: item.id, // 고유한 키 (문자열 추천)
            // userCount: item.userCount,
            children: item.children ? transformToTreeData(item.children) : []
        }));
    };

    // const handleServiceChange = (e) => {
    //     const selected = e.target.value;
    //     setSelectedServiceId(selected);
    //     setSelectedGroup(null); // 서비스 변경 시 선택된 페이지 초기화
    // };

    const handleSelect = (selectedKeys, info) => {
        setPage(0)

        if (!info || !info.node) {
            console.warn('handleSelect: info or info.node is undefined!', info);
            return;
        }

        const selected = info.node;
        setSelectedGroup(selected);
        setSelectedGroupUsers([]); // ← 미리 초기화!
        getGroupUsersAll(info.node.key);
    };


    const getGroupUsersAll = async (groupId, page = 0, size = listSize, searchType, keyword) => {
        setUsersLoading(true);

        if (searchType == "status") {
            switch (keyword) {
                case '할당됨':
                    keyword = 'active';
                    break;
                case '미할당':
                    keyword = 'deactive';
                    break;
                case '만료':
                    keyword = 'expiration';
                    break;
                case '':
                    keyword = '';
                    break;
                default:
                    return alert("잘못된 입력입니다.(검색어 : 할당됨, 미할당, 만료)");
            };
        }

        const groupUsersAll = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/all";

        const conditions = []
        if (searchType == "" || keyword == "") {
            conditions.push({
                "operator": "",
                "conditions": [
                    { "field": "groupId", "operator": "equals", "value": groupId }
                ]
            });
        } else if (searchType == "status") {
            conditions.push({
                "operator": "AND",
                "conditions": [
                    { "field": "groupId", "operator": "equals", "value": groupId },
                    { "field": searchType, "operator": "equals", "value": keyword }
                ]
            });
        } else {
            conditions.push({
                "operator": "AND",
                "conditions": [
                    { "field": "groupId", "operator": "equals", "value": groupId },
                    { "field": searchType, "operator": "like", "value": keyword }
                ]
            });
        }

        const params = {
            startDate: 0,
            endDate: 0,
            page: page,
            size: size,
            sortField: ["id"],
            sortOrder: ["desc"],
            operator: "",
            conditions: conditions
        };

        await axios.post(groupUsersAll, params)
            .then((res) => {
                setTotalCount(res.data.data.totalCount);
                setSelectedGroupUsers(res.data.data.data.map(item => ({ ...item })));

            })
            .catch((e) => {
                console.error(e);
                showDialog(DialogEnum.DEFAULT, "실패", "사용자 정보 조회에 실패했습니다.");
            })
            .finally(() => {
                setUsersLoading(false);
            });
    };

    useEffect(() => {
        if (selectedGroup) {
            getGroupUsersAll(selectedGroup.key, page, listSize);
        }
    }, [page]);

    const handleNextPage = () => {
        setPage((prevPage) => {
            const newPage = prevPage + 1;
            return newPage;
        });
    };

    const handlePrevPage = () => {
        setPage((prevPage) => {
            const newPage = Math.max(prevPage - 1, 0);
            return newPage;
        });
    };


    const handleSearch = (searchType, keyword, groupId) => {
        setPage(0);
        getGroupUsersAll(groupId, 0, listSize, searchType, keyword)
        // users.filter(...) 와 같은 클라이언트 필터링도 가능
    };


    // 권한만 다시 가져오는 함수
    const reloadGoupUsres = (groupId) => {
        // 1. 유저 테이블 갱신
        getGroupUsersAll(groupId, page, listSize);
        // 2. 트리도 갱신
        fetchData(groupId);
    }

    // 그룹 유저 추가 모달 핸들러
    const handleAddGroupUsers = () => {
        //그룹 선택해서 넘어가야함
        if (selectedGroup == null) {
            alert("그룹이 선택되지 않았습니다.")
        }
        else {
            const modalContent = <GroupUserRegisterModal update={reloadGoupUsres}
                selectedServiceId={selectedServiceId} groupId={selectedGroup != null ? selectedGroup.key : ""} products={idToNameMap} />
            const modalOption = { modalTitle: '유저 추가' }
            openModal(<DetailModal content={modalContent} option={modalOption} />)
        }
    };

    // 그룹 유저 삭제
    const handleDeleteGroupUsers = (groupId, selectedIds) => {
        setLoading(true)

        const url = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/delete";
        axios.post(url, { ids: selectedIds })
            .then((res) => {
                if (res.data.code == 200) {
                    showDialog(DialogEnum.SUCCESS, "성공", res.data.message, closeModal);
                } else {
                    showDialog(DialogEnum.DEFAULT, "실패", res.data.message);
                }
            })
            .catch((e) => {
                showDialog(DialogEnum.DEFAULT, "실패", e.response.data.resultMessage);
            })
            .finally(() => {
                reloadGoupUsres(groupId);
                setLoading(false)
            });

    };

    // 페이지 상세정보 모달 핸들러
    const handleDetailInfo = (node) => {
        const modalContent = <GroupDetailModal id={node.key} update={fetchData} />
        const modalOption = { modalTitle: '그룹 정보' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    const onAddGroup = (node) => {
        const groupId = node?.key || "0";
        const modalContent = (
            <GroupRegisterModal
                update={fetchData}
                selectedServiceId={selectedServiceId}
                groupData={treeData}
                selectedGroupId={groupId}
            />
        );
        const modalOption = { modalTitle: '그룹 등록' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    const handleRowClick = (userId) => {
        const modalContent = <GroupUserDetailModal update={reloadGoupUsres} userId={userId} products={idToNameMap} />
        const modalOption = { modalTitle: '유저 정보' }
        openModal(<DetailModal content={modalContent} option={modalOption} />)
    };

    //----------------------------------------------------
    // // 삭제
    // const handleDeleteSelected = () => {
    //     if (selected.length > 0) {
    //     onDeleteUsers(selected); // 리스트로 넘김
    //     setSelected([]);
    //     }
    // };

    //----------------------------------------------------

    const [showGroupTree, setShowGroupTree] = useState(true);

    const createExcel = async (groupId, searchType, keyword) => {
        const groupUsersAll = IAM_PATH + IAM_SERVER_SERVICE_ACOUNT + "/excel";

        const conditions = []
        if (searchType == "" || keyword == "") {
            conditions.push({
                "operator": "",
                "conditions": [
                    { "field": "groupId", "operator": "equals", "value": groupId }
                ]
            });
        } else if (searchType == "status") {
            conditions.push({
                "operator": "AND",
                "conditions": [
                    { "field": "groupId", "operator": "equals", "value": groupId },
                    { "field": searchType, "operator": "equals", "value": keyword }
                ]
            });
        } else {
            conditions.push({
                "operator": "AND",
                "conditions": [
                    { "field": "groupId", "operator": "equals", "value": groupId },
                    { "field": searchType, "operator": "like", "value": keyword }
                ]
            });
        }

        const params = {
            startDate: 0,
            endDate: 0,
            page: -1,
            size: -1,
            sortField: ["id"],
            sortOrder: ["desc"],
            operator: "",
            conditions: conditions
        };

        try {
            // 2. await를 사용하여 API 응답을 기다립니다.
            const response = await axios.post(groupUsersAll, params, {
                responseType: 'blob',
            });

            // 2. Blob 객체 생성: 응답으로 받은 바이너리 데이터(response.data)로 Blob 객체를 생성합니다.
            const blob = new Blob([response.data], {
                type: response.headers['content-type']
            });

            // 3. 파일 이름 추출: 서버 응답 헤더에서 파일 이름을 가져옵니다.
            // Content-Disposition: attachment; filename="사용자_목록.xlsx"
            const contentDisposition = response.headers['content-disposition'];
            let fileName = 'download.xlsx'; // 기본 파일 이름
            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch.length === 2)
                    fileName = decodeURI(fileNameMatch[1]); // 한글 파일 이름 디코딩
            }

            // 4. 다운로드를 위한 임시 링크 생성 및 실행
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // 다운로드될 파일 이름 설정
            document.body.appendChild(link);
            link.click();

            // 5. 임시 링크 및 URL 제거
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("❌ Excel 다운로드 실패:", error);
            // Blob 데이터를 텍스트로 변환하여 에러 메시지 확인 (서버가 JSON 에러를 보냈을 경우)
            if (error.response && error.response.data.toString() === '[object Blob]') {
                const reader = new FileReader();
                reader.onload = () => {
                    const errorData = JSON.parse(reader.result);
                    console.error("서버 에러 메시지:", errorData);
                    // 여기서 사용자에게 에러 알림창을 띄울 수 있습니다.
                    showDialog("실패", "서버에서 오류가 발생했습니다.");
                };
                reader.readAsText(error.response.data);
            } else {
                // 네트워크 에러 등
                showDialog("실패", "파일 다운로드 중 오류가 발생했습니다.");
            }
        }
    };

    return (
        <div className={"adminWrap"}>
            <NavBar type={NavType.GROUP} />
            <section className={"rightCont"}>
                <Header />
                {loading ? <Loading /> :
                    <div className={"rightCont__cont"}>
                        <h2 className={styles.sectionTitle}>· 계정 관리</h2>
                        {userInfo.role == 'SYS_ADMIN' && (
                            <div style={{ display: "flex" }}>
                                <button
                                    onClick={() => setShowGroupTree(!showGroupTree)}
                                    style={{ margin: '5px', color: 'gray' }}
                                >
                                    {showGroupTree ? <FaAngleDoubleLeft size={30} /> : <FaAngleDoubleRight size={30} />}
                                </button>
                            </div>
                        )}
                        <div style={{ display: "flex" }}>
                            {userInfo.role == 'SYS_ADMIN' && showGroupTree && (
                                <>
                                    <div className={styles.rightCont__cont__tableWrap} style={{ marginRight: "5px", width: "250px", minWidth: "200px" }}>
                                        <div className={styles.actionBar}>
                                            {/* {groupId !== "0" && (
                                                <>
                                                    <button onClick={handleDeleteSelected} className={styles.deleteBtn} disabled={selected.length === 0}>제거</button>
                                                    <button onClick={onAddUser} className={styles.addBtn}> 유저 추가 </button>
                                                </>
                                                )} */}
                                        </div>
                                        <div className={styles.pageAuthLayout}>
                                            {/* <div className={styles.treeContainer}> */}
                                            <div className={styles.treeWrapper}>
                                                <div className={styles.matrixButtons} style={{ borderBottom: "1px solid #e0e0e0" }}>
                                                    <button className={styles.actionButton} style={{ marginBottom: "8px" }} onClick={onAddGroup}>그룹 등록</button>
                                                </div>
                                                <div className={styles.pageTree}>
                                                    <GroupTree
                                                        treeData={treeData}
                                                        onSelect={handleSelect}
                                                        onDetailClick={handleDetailInfo}
                                                        onAddGroup={onAddGroup}
                                                    />
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className={styles.rightCont__cont__tableWrap} style={{ flex: "1" }}>
                                <div className={styles.permissionPanel}>
                                    <GroupUserTable
                                        groupId={selectedGroup != null ? selectedGroup.key : ""}
                                        users={selectedGroupUsers}
                                        onAddUser={handleAddGroupUsers}
                                        onDeleteUsers={handleDeleteGroupUsers}
                                        detailUser={handleRowClick}
                                        onPrevPage={handlePrevPage}
                                        onNextPage={handleNextPage}
                                        disablePrev={page === 0}
                                        disableNext={(page + 1) * listSize >= totalCount}
                                        pageNumber={page}
                                        totalCount={totalCount}
                                        listSize={listSize}
                                        searchValue={searchValue}
                                        setSearchValue={setSearchValue}
                                        onSearch={handleSearch}
                                        isMobileWindow={isMobileWindow}
                                        products={idToNameMap}
                                        createExcel={createExcel}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* <p className={"rightCont__cont__copyright"}> ⓒ 2025. Innocode. All rights reserved.</p> */}
                    </div>
                }
            </section>
        </div>
    )
}

export default Group;